import { memo, useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";
import {
  blockStorageCoordinateConverter,
  nonLGVCoordinateConverter,
  rackStorageCoordinateConverter
} from "./coordConverter";
import { setIsDrawerOpen } from "../../store/inventorySlice";
import { deTransformLGVName } from "../FilterDrawer/utils";

const PanToLocation = ({
  mapObject = null,
  plantConfig = null,
  setZoomLevel,
  liveLgvData
}) => {
  const map = useMap();
  const [latLng, setLatLng] = useState(null);
  const { selectedResult } = useSelector((state) => state.inventory);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!(mapObject && plantConfig && selectedResult)) {
      if (latLng) setLatLng(null); // resets on clear
      return;
    }

    const {
      latitude,
      longitude,
      location,
      locationOrientation,
      positionLength,
      storageType
    } = selectedResult;

    const { nonLgvStorage, blockStorage, rackStorage, lgvs } =
      plantConfig?.indoorMap;

    switch (storageType) {
      case "lgv": {
        const lgvToBeHighlighted = deTransformLGVName(location);
        const { groupOffset } = lgvs;
        const LGV = liveLgvData.find(
          ({ vehicleNumber }) => lgvToBeHighlighted === vehicleNumber
        );

        setLatLng([
          LGV?.currentPos?.lat + groupOffset?.x,
          LGV?.currentPos?.lng + groupOffset?.y
        ]);
        break;
      }

      case "nonLGV": {
        setLatLng(nonLGVCoordinateConverter(nonLgvStorage, mapObject));
        break;
      }

      case "block": {
        setLatLng(
          blockStorageCoordinateConverter({
            latitude,
            longitude,
            location,
            locationOrientation,
            positionLength,
            blockStorageConfig: blockStorage,
            mapObject
          })
        );
        break;
      }

      case "rack": {
        setLatLng(
          rackStorageCoordinateConverter({
            latitude,
            longitude,
            location,
            rackStorageConfig: rackStorage,
            mapObject
          })
        );
        break;
      }

      default:
        console.log("panTo default case", storageType);
    }
  }, [selectedResult, mapObject, plantConfig]);

  useEffect(() => {
    if (!latLng) return;

    map.panTo(latLng);
    //setting scale(3) from indoorMqp zoom scale config
    setZoomLevel(4);
    dispatch(setIsDrawerOpen(false));
  }, [latLng, map]);

  return null;
};

export default memo(PanToLocation);
